// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"968":"776b0b68","9453":"6024587e"}[chunkId] + ".chunk.css";
};